import { ORDER_WITH_ITEMS as ORDER_WITH_ITEMS_FIXTURE } from '../../../fixtures/orders.fixtures';

export const ORDER_WITH_ITEMS: any = ORDER_WITH_ITEMS_FIXTURE;
